import React from 'react';
import {SectionHeader, FlexItem} from '../../../CommonStyleUtils/dwebCommon.styles';
import {
  ContentWrapperDiv,
  OuterWrapperDiv,
  HeadingWrapperDiv,
  FilterCategoryWrapperDiv,
} from './UGCRnR.styles';

import {shallowEqual, useSelector} from 'react-redux';

import RnrSorting from './../RnrSorting/RnrSorting';
import RnrFilter from './../RnrFilter/RnrFilter';
import TaRnr from './../TaRnr/TaRnr';
import RnR from '../RnR/RnR';
import TripAdvisor from '../TripAdvisor/TripAdvisor';

//Selectors
import {
  snapDataSelector,
  selectedRnRType,
} from '@stencil/hotels-ugc-redux/src/hotels-ugc-selectors';
const UGCRnR = () => {
  const snapData = useSelector(snapDataSelector, shallowEqual);
  const selectedTab = useSelector(selectedRnRType, shallowEqual);
  const {giDataExists = true, taDataExists} = snapData;

  return (
    <ContentWrapperDiv>
      <OuterWrapperDiv>
        <HeadingWrapperDiv>
          <SectionHeader>Guest Reviews & Rating</SectionHeader>
          {selectedTab === 'gi' && (
            <FlexItem>
              <RnrSorting />
              <FilterCategoryWrapperDiv>
                <RnrFilter />
              </FilterCategoryWrapperDiv>
            </FlexItem>
          )}
        </HeadingWrapperDiv>
        {giDataExists && taDataExists && <TaRnr />}
        {giDataExists && !taDataExists && <RnR />}
        {!giDataExists && taDataExists && <TripAdvisor />}
      </OuterWrapperDiv>
    </ContentWrapperDiv>
  );
};

export default UGCRnR;
